import type { VideoRow } from "./schema";

function normalize(value: string | null | undefined) {
  return value?.trim().toLowerCase() ?? "";
}

function containsPreviewLabel(value: string | null | undefined) {
  return /\bpreview\b/i.test(value?.trim() ?? "");
}

/**
 * Purchased/tutorial playback should only show the paid tutorial/performance videos.
 * Some imported rows have a missing or inconsistently-cased `video_type`, so fall back
 * to the title as well to avoid exposing the public preview as a third dashboard video.
 */
export function isPreviewVideo(video: Pick<VideoRow, "title" | "video_type">) {
  const videoType = normalize(video.video_type);

  return videoType === "preview" || containsPreviewLabel(video.video_type) || containsPreviewLabel(video.title);
}

export function filterPurchasedCourseVideos<T extends Pick<VideoRow, "title" | "video_type">>(videos: T[] | null) {
  return videos?.filter((video) => !isPreviewVideo(video)) ?? null;
}
